import { OverlayRef } from '@angular/cdk/overlay';
import { Component, Inject } from '@angular/core';
import { ToasterService } from '../../services';

@Component({
  selector: 'gps-tracker-custom-toaster',
  standalone: false,
  templateUrl: './custom-toaster.component.html',
  styleUrl: './custom-toaster.component.scss'
})
export class CustomToasterComponent {

  constructor(
    @Inject('TOASTER_DATA') public data: any,
    private overlayRef: OverlayRef,
    private toasterService: ToasterService
  ) { }

  closeToast() {
    this.toasterService.closeToast(this.overlayRef);
  }
}
